import { createContext } from 'react';

import { ChipProps } from '../../../Chip/Chip.types';

export interface ChipGroupItemProps
  extends Omit<ChipProps, 'rounded' | 'size' | 'error' | 'focus' | 'selected'> {
  value: string;
}

export interface ChipGroupContext {
  showCheckMark?: boolean;
  size: 'small' | 'medium' | 'large';
  selectedValues: string[];
  onSelectValue: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
}

export const chipGroupContext = createContext<ChipGroupContext | null>(null);
